import racket from "./racket.svg";

interface RacketIconProps {
  className?: string;
  size?: number | string;
}

// Tennis racket icon (assets/icons/racket.svg).
// Rendered as a CSS mask so it inherits `currentColor` like the FontAwesome
// person icon it sits next to — the source SVG has a hardcoded black fill.
function RacketIcon({ className, size = "1em" }: RacketIconProps) {
  return (
    <span
      className={className}
      aria-hidden="true"
      style={{
        display: "inline-block",
        width: size,
        height: size,
        backgroundColor: "currentColor",
        WebkitMaskImage: `url(${racket})`,
        maskImage: `url(${racket})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        verticalAlign: "-0.125em",
        flexShrink: 0,
      }}
    />
  );
}

export default RacketIcon;
